import React from 'react';
interface PullQuoteProps {
  text: string;
  variant?: 'dark' | 'light';
}
export function PullQuote({
  text,
  variant = 'dark'
}: PullQuoteProps) {
  const isDark = variant === 'dark';
  return <div className={`border-l-4 border-tealslate pl-6 py-4 my-8 ${isDark ? 'bg-bluegray/10' : 'bg-[#EAEAE4]'}`} data-id="element-2559">
      <p className={`text-base font-serif italic leading-relaxed ${isDark ? 'text-white' : 'text-[#1F1F1F]'}`} data-id="element-2560">
        "{text}"
      </p>
    </div>;
}